import { render, staticRenderFns } from "./AddCustomer.vue?vue&type=template&id=b325ea02&scoped=true&"
import script from "./AddCustomer.vue?vue&type=script&lang=js&"
export * from "./AddCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b325ea02",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b325ea02')) {
      api.createRecord('b325ea02', component.options)
    } else {
      api.reload('b325ea02', component.options)
    }
    module.hot.accept("./AddCustomer.vue?vue&type=template&id=b325ea02&scoped=true&", function () {
      api.rerender('b325ea02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Modal/AdminPage/CustomersPage/AddCustomer.vue"
export default component.exports